import logo from '../../assets/logo.svg';
import './Spinner.scss';

export function Spinner() {
  return (
    <div id='container'>
      <img className='spinner' src={logo} />
    </div>
  )
}
